import { useState } from "react";
import { X } from "lucide-react";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const MultiSelect = ({ options, selected, onChange, maxItems = 3, placeholder = "Seleccionar" }) => {
  const [tempValue, setTempValue] = useState("");

  const handleAdd = (value) => {
    if (value && !selected.includes(value) && selected.length < maxItems) {
      onChange([...selected, value]);
      setTempValue("");
    }
  };

  const handleRemove = (value) => {
    onChange(selected.filter(item => item !== value));
  };

  const availableOptions = options.filter(opt => !selected.includes(opt));

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <Select value={tempValue} onValueChange={handleAdd}>
          <SelectTrigger className="bg-slate-900 border-slate-700 text-white">
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent>
            {availableOptions.map((option) => (
              <SelectItem key={option} value={option}>{option}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {selected.map((item) => (
            <div
              key={item}
              className="inline-flex items-center gap-1 px-2 py-1 bg-cyan-600/30 text-cyan-300 rounded text-sm"
            >
              <span>{item}</span>
              <button
                onClick={() => handleRemove(item)}
                className="hover:text-white"
              >
                <X className="w-3 h-3" />
              </button>
            </div>
          ))}
        </div>
      )}
      
      {selected.length >= maxItems && (
        <p className="text-xs text-amber-400">Máximo {maxItems} seleccionados</p>
      )}
    </div>
  );
};
